import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar, { infoUtente, loadNav } from "../../visualComponents/NavBarManager.js";
import { History, ArrowDownAZ, ArrowUpAZ, SquareArrowUpRight, Pen, Trash2, X } from 'lucide-react';
import TempStorage from '../../components/Storage';
import Loader from '../../visualComponents/Loader.js';
import Tooltip from "../../components/Tooltip.js";
import ToggleSwitch from '../../visualComponents/ToggleSwitch.js';

let isLoading = false;

const PopUpSIM = ({ isVisible, setIsVisible, data }) => {

    const closeModal = () => {
        setIsVisible(false);
    }

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-[90vw] text-black dark:text-white">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold">SIM</h2>
                    <button className="text-red-500" onClick={closeModal}>
                        <X size={24} />
                    </button>
                </div>
                <div>
                    {
                        data["SIM"] === true ? (
                            <>
                                <div className="mb-2 grid grid-cols-2">
                                    <p className="justify-self-start">Password: </p>
                                    <input
                                        type="text"
                                        value={data["Password"]}
                                        disabled={true}
                                        className="rounded bg-white dark:bg-gray-800 px-1"
                                    />
                                </div>
                                <div className="mb-2 grid grid-cols-2">
                                    <p className="justify-self-start">Scandeza SIM: </p>
                                    <input
                                        type="date"
                                        value={data["ScadenzaSIM"].split('/')[2] + "-" + data["ScadenzaSIM"].split('/')[1] + "-" + data["ScadenzaSIM"].split('/')[0]}
                                        disabled={true}
                                        className="rounded bg-white dark:bg-gray-800 px-1"
                                    />
                                </div></>

                        ) : (
                            <p className="text-center">Il cliente non ha una SIM associata.</p>
                        )
                    }
                </div>
            </div>
        </div>
    )
};

const PopUp = ({ isVisible, setIsVisible, data }) => {
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [scadenzaSIM, setScadenzaSIM] = useState("");
    const [indirizzo, setIndirizzo] = useState("");
    const [citta, setCitta] = useState("");
    const [provincia, setProvincia] = useState("");
    const [cap, setCap] = useState("");
    const [isSectionVisible, setIsSectionVisible] = useState(false);
    const inputRefs = useRef([]);
    const toggleRef = useRef(null);

    useEffect(() => {
        if (data && isVisible === true) {
            setNome(data["Nome"]);
            setEmail(data["Email"]);
            if (toggleRef.current) {
                toggleRef.current.setValue(data["SIM"]);
                setIsSectionVisible(data["SIM"]);
            }
            if (data["SIM"]) {
                setPassword(data["Password"]);
                setScadenzaSIM(data["ScadenzaSIM"].split('/')[2] + "-" + data["ScadenzaSIM"].split('/')[1] + "-" + data["ScadenzaSIM"].split('/')[0]);
            }
            setIndirizzo(data["Indirizzo"]);
            setCitta(data["Citta"]);
            setProvincia(data["Provincia"]);
            setCap(data["Cap"]);
        }
    }, [isVisible]);

    const closeModal = () => {
        resetData();
        setIsVisible(false);
    };

    const resetData = () => {
        setNome(data ? data["Nome"] : "");
        setEmail(data ? data["Email"] : "");
        if (toggleRef.current) {
            toggleRef.current.setValue(data ? data["SIM"] : false);
            setIsSectionVisible(data ? data["SIM"] : false);
        }
        if (data["SIM"]) {
            setPassword(data ? data["Password"] : "");
            setScadenzaSIM(data ? data["ScadenzaSIM"].split('/')[2] + "-" + data["ScadenzaSIM"].split('/')[1] + "-" + data["ScadenzaSIM"].split('/')[0] : "");
        }
        setIndirizzo(data ? data["Indirizzo"] : "");
        setCitta(data ? data["Citta"] : "");
        setProvincia(data ? data["Provincia"] : "");
        setCap(data ? data["Cap"] : "");
    };

    const handleConferma = async () => {
        if (data) {
            // Modifica
            try {
                isLoading = true;
                let toggleStatus = false;
                if (toggleRef.current) {
                    toggleStatus = toggleRef.current.getValue();
                }
                const response = await fetch("/aggiornaAzienda", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente.CodiceDominio,
                        ID: data["ID"],
                        Nome: nome,
                        Email: email,
                        SIM: toggleStatus,
                        Password: toggleStatus ? password : "",
                        ScadenzaSIM: toggleStatus ? scadenzaSIM : "",
                        Indirizzo: indirizzo,
                        Citta: citta,
                        Provincia: provincia,
                        Cap: cap
                    })
                });

                if (response.status === 500) {
                    const data = await response.json();
                    alert(data.error);
                    console.log(data.error);
                } else {
                    resetData();
                    isLoading = false;
                }
            } catch (error) {
                alert("Errore nella modifica del cliente, riprovare più tardi");
                console.log(error);
            }
        } else {
            // Aggiungi
            try {
                isLoading = true;
                let toggleStatus = false;
                if (toggleRef.current) {
                    toggleStatus = toggleRef.current.getValue();
                }
                const response = await fetch("/addAzienda", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente.CodiceDominio,
                        Nome: nome,
                        Email: email,
                        SIM: toggleStatus,
                        Password: toggleStatus ? password : "",
                        ScadenzaSIM: toggleStatus ? scadenzaSIM : "",
                        Indirizzo: indirizzo,
                        Citta: citta,
                        Provincia: provincia,
                        CAP: cap
                    })
                });

                if (response.status === 500) {
                    const data = await response.json();
                    alert(data.error);
                    console.log(data.error);
                } else {
                    isLoading = false;
                    resetData();
                }
            } catch (error) {
                alert("Errore nella creazione del cliente, riprovare più tardi");
                console.log(error);
            }
        }
        window.location.reload(true);
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evita il comportamento predefinito del form
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) {
                nextInput.focus(); // Passa al campo successivo
            }
        }
    };

    const handleToggleChange = (newValue) => {
        // console.log("Toggle cambiato:", newValue);
        setIsSectionVisible(newValue);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white rounded-lg p-6 w-100 max-w-[90vw]">
                <div className="flex justify-center items-center mb-6">
                    {data ? (
                        <h2 className="text-xl font-bold">Modifica Cliente</h2>
                    ) : (
                        <h2 className="text-xl font-bold">Aggiungi Cliente</h2>
                    )}
                </div>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Nome: </p>
                    <input
                        type="text"
                        value={nome}
                        onChange={(e) => setNome(e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, 0)}
                        ref={(el) => (inputRefs.current[0] = el)}
                        className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                    />
                </div>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Email: </p>
                    <input
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, 1)}
                        ref={(el) => (inputRefs.current[1] = el)}
                        className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                    />
                </div>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Indirizzo: </p>
                    <input
                        type="text"
                        value={indirizzo}
                        onChange={(e) => setIndirizzo(e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, 2)}
                        ref={(el) => (inputRefs.current[2] = el)}
                        className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                    />
                </div>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Città: </p>
                    <input
                        type="text"
                        value={citta}
                        onChange={(e) => setCitta(e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, 3)}
                        ref={(el) => (inputRefs.current[3] = el)}
                        className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                    />
                </div>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Provincia: </p>
                    <input
                        type="text"
                        value={provincia}
                        onChange={(e) => setProvincia(e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, 4)}
                        ref={(el) => (inputRefs.current[4] = el)}
                        className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                    />
                </div>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">CAP: </p>
                    <input
                        type="text"
                        value={cap}
                        onChange={(e) => setCap(e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, 5)}
                        ref={(el) => (inputRefs.current[5] = el)}
                        className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                    />
                </div>
                <div>
                    <div className="mb-2 grid grid-cols-2">
                        <p className="justify-self-start">SIM: </p>
                        <ToggleSwitch ref={toggleRef} onToggleChange={handleToggleChange} />
                    </div>
                    {isSectionVisible ? (
                        <>
                            <div className="mb-2 grid grid-cols-2">
                                <p className="justify-self-start">Password: </p>
                                <input
                                    type="text"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                                />
                            </div>
                            <div className="mb-2 grid grid-cols-2">
                                <p className="justify-self-start">Scandeza SIM: </p>
                                <input
                                    type="date"
                                    value={scadenzaSIM}
                                    onChange={(e) => setScadenzaSIM(e.target.value)}
                                    className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                                />
                            </div>
                        </>
                    ) : null}
                </div>
                <div className='mt-3 grid grid-cols-2'>
                    <button
                        onClick={closeModal}
                        className="mr-1 rounded-md py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={handleConferma}
                        className="ml-1 rounded-md py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                    >
                        Conferma
                    </button>
                </div>
            </div>
        </div>
    );
};

const TableRow = ({ data }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isSIMVisible, setIsSIMVisible] = useState(false);
    const navigate = useNavigate();

    const handleElimina = async () => {
        if (!window.confirm("Sei sicuro di voler eliminare questo cliente?")) return;
        try {
            isLoading = true;
            const response = await fetch('/eliminaAzienda', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"], ID: data.ID })
            });

            if (response.status === 500) {
                const data = await response.json();
                alert(data.error);
                console.log(data.error);
                window.location.reload(true);
            }
            else {
                isLoading = false;
                window.location.reload(true);
            }
        } catch (error) {
            alert("Operazione fallita, riprova più tardi.");
            console.log(error);
        }

    };

    return (
        <div className="grid grid-cols-10 gap-1 md:gap-4 mt-2">
            <div></div>
            <div className="col-span-8 bg-gray-300 dark:bg-gray-500 rounded-lg grid grid-cols-8 p-4 text-center break-words divide-x divide-black dark:divide-white">
                <div>{data["Nome"]}</div>
                <div>{data["Email"]}</div>
                <div>{data["Indirizzo"]}</div>
                <div>{data["Citta"]}</div>
                <div>{data["Provincia"]}</div>
                <div>{data["Cap"]}</div>
                <div>
                    <Tooltip content="SIM">
                        <button className="text-blue-500" onClick={() => { setIsSIMVisible(true) }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-card-sim-icon lucide-card-sim"><path d="M12 14v4" /><path d="M14.172 2a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 20 7.828V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" /><path d="M8 14h8" /><rect x="8" y="10" width="8" height="8" rx="1" /></svg>
                        </button>
                    </Tooltip>
                </div>
                <div>
                    {
                        data["Obsoleta"] === false ? (
                            <Tooltip content="Componenti">
                                <button className="text-blue-500" onClick={() => { navigate('/dashManager/componenti'); TempStorage.set("PreselectAzienda", data.ID); document.cookie = "PreselectAzienda=" + data.ID + "; path=/"; }}>
                                    <SquareArrowUpRight size={24} />
                                </button>
                            </Tooltip>
                        ) : null
                    }
                </div>
            </div>
            <div className="flex items-center gap-1 md:gap-4 ">
                {data.Obsoleta === false ? (
                    <>
                        <Tooltip content="Modifica">
                            <button className="text-blue-500" onClick={() => setIsVisible(true)}>
                                <Pen size={24} />
                            </button>
                        </Tooltip>

                        <Tooltip content="Elimina">
                            <button className="text-red-500" onClick={handleElimina}>
                                <Trash2 size={24} />
                            </button>
                        </Tooltip>
                    </>
                ) : null
                }
            </div>
            <PopUp isVisible={isVisible} setIsVisible={setIsVisible} data={data} />
            <PopUpSIM isVisible={isSIMVisible} setIsVisible={setIsSIMVisible} data={data} />
        </div>
    );
};

const AziendeManager = () => {
    const navigate = useNavigate();
    const [indexTabella, setIndexTabella] = useState([
        { value: "Nome", dbCode: "Nome", ascending: true, filter: "text" },
        { value: "Email", dbCode: "Email", ascending: true, filter: "text" },
        { value: "Indirizzo", dbCode: "Indirizzo", ascending: true, filter: "text" },
        { value: "Città", dbCode: "Citta", ascending: true, filter: "text" },
        { value: "Provincia", dbCode: "Provincia", ascending: true, filter: "text" },
        { value: "CAP", dbCode: "Cap", ascending: true, filter: "text" },
        { value: "SIM", ascending: true },
        { value: "Componenti", ascending: true }
    ]);
    const [filters, setFilters] = useState({
        Nome: "",
        Email: "",
        Indirizzo: "",
        Citta: "",
        Provincia: "",
        Cap: ""
    });
    const [data, setData] = useState([]);
    const [viewData, setViewData] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [archive, setArchive] = useState(false);

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        setViewData(data.filter((d) => d.value["Obsoleta"] === archive));
    }, [data]);

    useEffect(() => {
        let newData = [...data];
        for (const key in filters) {
            if (filters[key] !== "") {
                newData = newData.filter((d) => (d.value[key].toString().toLowerCase().includes(filters[key].toLowerCase())));
            }
        };
        setViewData(newData.filter((d) => d.value["Obsoleta"] === archive));
    }, [filters]);

    const onload = async () => {
        //getInfoUtente
        try {
            isLoading = true;
            await loadNav();
            //loadDati
            const r2 = await fetch('/getAziende', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio
                })
            });
            const rd2 = await r2.json();
            if (r2.status === 500) {
                alert(rd2.error);
                console.log(rd2.error);
                navigate('/dashManager');
            } else {
                isLoading = false;
                setData(rd2.map(item => ({ value: item })));
            }

        } catch (error) {
            alert("Errore nel caricamento della pagina, riprovare più tardi");
            console.log(error);
            navigate('/dashManager');
        }
    };

    const sortByColumn = (column) => {
        setIndexTabella((prevIndexTabella) =>
            prevIndexTabella.map((d) =>
                d.dbCode === column ? { ...d, ascending: !d.ascending } : d
            )
        );
        const isAscending = indexTabella.find((d) => d.dbCode === column)?.ascending;
        let newData = [...viewData];

        newData.sort((a, b) => {
            if (a.value[column] > b.value[column]) return isAscending ? -1 : 1;
            if (a.value[column] < b.value[column]) return isAscending ? 1 : -1;
            return 0;
        });

        setViewData(newData);
    };

    const handleArchive = () => {
        const newArchive = !archive;
        setArchive(newArchive);
        let newData = [...data];
        newData = newData.filter((d) => d.value["Obsoleta"] === newArchive);
        setViewData(newData);
    };

    const handleAdd = () => {
        setIsVisible(true);
    };

    return (
        <div className='min-h-screen bg-white dark:bg-gray-800'>
            <NavBar page={"CLIENTI"} />
            {isLoading && <Loader />}
            <div className='p-4 bg-white dark:bg-gray-800 text-black dark:text-white'>
                <div className='flex justify-center'>
                    <button className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mt-14" onClick={handleAdd}>
                        Aggiungi Cliente
                    </button>
                </div>
                <div id='tabella'>
                    <div className="grid grid-cols-10 gap-4 mt-4">
                        <div></div>
                        <div className="col-span-8 bg-gray-400 dark:bg-gray-600 rounded-lg grid grid-cols-8 p-4 font-bold text-center divide-x divide-black dark:divide-white">
                            {
                                indexTabella.map((d, index) => (
                                    d.value !== "Componenti" || d.value !== "SIM" ? (
                                        <div key={index} onClick={() => sortByColumn(d.dbCode)} className="hover:cursor-pointer grid grid-cols-1 md:flex md:items-center md:justify-center">
                                            <p className="text-[2vw] md:text-base flex items-center justify-self-center">{d.value}</p>
                                            <Tooltip content="Ordina">
                                                <button className="ml-2 text-gray-500 dark:text-gray-700 justify-self-center">
                                                    {d.ascending ? <ArrowDownAZ size={24} /> : <ArrowUpAZ size={24} />}
                                                </button>
                                            </Tooltip>
                                        </div>
                                    ) : (
                                        <div key={index} className="grid grid-cols-1 md:flex md:items-center md:justify-center">
                                            <p className="text-[2vw] md:text-base flex items-center justify-self-center">{d.value}</p>
                                        </div>
                                    )
                                ))
                            }
                        </div>
                        <div>
                        </div>
                    </div>
                    <div className="grid grid-cols-10 gap-4 mt-2">
                        <div></div>
                        <div className="col-span-8 rounded-lg grid grid-cols-8 p-4 font-bold text-center divide-x divide-black dark:divide-white">
                            {
                                indexTabella.map((d, index) => (
                                    d.value !== "Componenti" || d.value !== "SIM" ? (
                                        <div key={index} className={`flex items-center justify-center ${index === 0 ? "mr-2" : index === 8 ? "pl-2" : "px-2"}`}>
                                            <input
                                                type={d.filter}
                                                placeholder={d.value}
                                                value={filters[d.dbCode]}
                                                className="text-[2vw] md:text-base rounded bg-gray-100 dark:bg-gray-300 border-2 border-gray-200 dark:border-gray-400 p-1 md:px-1 text-center w-full"
                                                onChange={(e) => setFilters({ ...filters, [d.dbCode]: e.target.value })}
                                            />
                                        </div>
                                    ) : (<div></div>)
                                ))
                            }
                        </div>
                        <div className='flex items-center'>
                            <Tooltip content="Archivio">
                                <button className={!archive ? "text-yellow-700" : "text-yellow-300"} onClick={handleArchive}>
                                    <History size={24} />
                                </button>
                            </Tooltip>
                        </div>
                    </div>
                    {viewData.map((d, index) => (
                        <TableRow key={index} data={d.value} />
                    ))}
                </div>
            </div>
            <PopUp isVisible={isVisible} setIsVisible={setIsVisible} />
        </div>
    );
};

export default AziendeManager;